export default {
  brand: 'USFansSheet.help',
  language: 'Idioma',

  'meta.title': 'USFans Spreadsheet 2026 — Hallazgos, QC, Reseñas y Guías de Compra',
  'meta.desc': 'Explora la USFans Spreadsheet con hallazgos, guías QC, reseñas, costos de envío e información de seguridad. Actualizado para 2026.',
  'meta.articleTitle': '¿Qué es la USFans Spreadsheet? Guía Completa 2026',
  'meta.articleDesc': 'Aprende qué es la USFans Spreadsheet, cómo usarla, sus categorías, QC, envío y consejos de seguridad en esta guía para principiantes.',

  'nav.home': 'Inicio',
  'nav.shop': 'Guía de compras',
  'nav.spreadsheet': 'Hoja',
  'nav.categories': 'Categorías',
  'nav.guides': 'Guías',

  'hero.badge': 'Recurso independiente · Actualizado para 2026',
  'hero.title': 'USFans Spreadsheet — Encuentra Mejores Productos, QC y Guías de Compra',
  'hero.subtitle': 'Explora la USFans Spreadsheet en un solo centro organizado. Descubre hallazgos de productos, guías de categorías, consejos de QC, información de envío y recursos de seguridad antes de comprar.',
  'hero.ctaPrimary': 'USFans Spreadsheet',
  'hero.ctaSecondary': 'Cómpralo Ya',
  'hero.trust': 'Independiente · Centrado en la seguridad · Multilingüe',

  'categories.title': 'Explora las Categorías de Productos',
  'categories.subtitle': 'Salta directamente a cualquier categoría en la plataforma principal.',
  'categories.dropdownLabel': 'Elige una categoría',
  'categories.viewAll': 'Ver todas las categorías',

  'cat.shoes': 'Zapatos',
  'cat.hoodies': 'Sudadera / Suéteres',
  'cat.tshirts': 'Camisetas',
  'cat.jackets': 'Chaquetas',
  'cat.pants': 'Pantalones / Shorts',
  'cat.headwear': 'Gorros y Gorras',
  'cat.sets': 'Conjuntos',
  'cat.underwear': 'Ropa Interior',
  'cat.jersey': 'Camiseta Deportiva',
  'cat.accessories': 'Accesorios',
  'cat.bags': 'Bolsos',
  'cat.belts': 'Cinturones',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Otros Artículos',

  'what.title': '¿Qué es la USFans Spreadsheet?',
  'what.p1': 'La USFans Spreadsheet es una forma estructurada de organizar hallazgos de productos, enlaces, categorías e información de compra en un solo lugar.',
  'what.p2': 'En lugar de desplazarte por páginas interminables, la hoja te ayuda a comparar opciones, revisar notas de QC y entender los procesos de envío y almacén antes de hacer un pedido.',
  'what.p3': 'Está diseñada como un directorio informativo — un atajo de investigación para cualquiera que quiera explorar productos de forma más eficiente.',
  'what.cta': 'Descubre Cómo Funciona',
  'what.finds.title': 'Hallazgos de productos',
  'what.finds.desc': 'Explora descubrimientos organizados en cada categoría.',
  'what.qc.title': 'Fotos QC',
  'what.qc.desc': 'Revisa las fotos de control de calidad antes de confirmar.',
  'what.shipping.title': 'Envío',
  'what.shipping.desc': 'Comprende rutas, peso y costos de consolidación.',
  'what.sellers.title': 'Vendedores',
  'what.sellers.desc': 'Verifica datos y reputación del vendedor antes de comprar.',

  'guideCard.title': 'La Guía Completa de USFans Spreadsheet',
  'guideCard.summary': 'Todo lo que necesitas saber sobre la USFans Spreadsheet — qué es, cómo usarla, categorías, QC, envío y seguridad — en una guía apta para principiantes.',
  'guideCard.readTime': '8 min de lectura',
  'guideCard.cta': 'Leer la guía',

  'pillar.title': 'Últimas guías y reseñas',
  'pillar.subtitle': 'Artículos frescos y detallados sobre la USFans Spreadsheet: reseñas, envío, seguridad y más.',
  'pillar.readMore': 'Leer artículo',

  'cat.label.review': 'Reseña',
  'cat.label.shipping': 'Envío',
  'cat.label.coupon': 'Cupón',
  'cat.label.warehouse': 'Almacén',
  'cat.label.safety': 'Seguridad',
  'cat.label.qc': 'Guía QC',
  'cat.label.guide': 'Guía',

  'faq.title': 'Preguntas Frecuentes',
  'faq.q1': '¿Qué es la USFans Spreadsheet?',
  'faq.a1': 'Es un directorio informativo que organiza hallazgos de productos, enlaces, categorías y notas de compra para que puedas investigar antes de comprar.',
  'faq.q2': '¿Es seguro usar la USFans Spreadsheet?',
  'faq.a2': 'Una hoja es un directorio de información, no una garantía. Verifica siempre los enlaces, vendedores y detalles en la plataforma principal antes de comprar.',
  'faq.q3': '¿Cómo funcionan los costos de envío?',
  'faq.a3': 'El envío depende del peso, las dimensiones, el destino y la ruta o nivel de servicio elegido. La consolidación también puede cambiar el precio final.',
  'faq.q4': '¿Dónde encuentro códigos de descuento?',
  'faq.a4': 'Las promociones las publica la propia plataforma. Revisa los canales oficiales en el sitio principal y verifica siempre las condiciones y la caducidad.',
  'faq.q5': '¿Es legítimo USFans?',
  'faq.a5': 'USFans es una plataforma real, pero siempre recomendamos verificar de forma independiente a los vendedores, la información de pago y los enlaces antes de pedir.',

  'footer.disclaimer': 'USFansSheet.help es un recurso informativo independiente y no está afiliado, respaldado ni operado por USFans.',
  'footer.rights': 'Todos los derechos reservados.',
  'footer.about': 'Acerca de este sitio',

  'notFound.title': 'Página no encontrada',
  'notFound.desc': 'La página que buscas no existe o se ha movido.',

  'article.backHome': 'Volver al inicio',
  'article.notFound': 'Artículo no encontrado',
  'article.updated': 'Última actualización',
  'article.readTime': 'Tiempo de lectura',
  'article.minRead': 'min de lectura',
  'article.title': '¿Qué es la USFans Spreadsheet? Guía Completa 2026',
  'article.quickAnswerTitle': 'Respuesta Rápida',
  'article.quickAnswer': 'La USFans Spreadsheet es un directorio informativo que organiza hallazgos de productos, enlaces de categorías, notas de QC y orientación de compra en un solo lugar estructurado. Te ayuda a investigar productos antes de comprar — pero no vende nada por sí misma y no es una garantía de que cada vendedor o enlace sea seguro.',
  'article.tocTitle': 'En esta página',

  'article.s1Title': '¿Qué es la USFans Spreadsheet?',
  'article.s1Body': 'La USFans Spreadsheet es una forma centralizada de explorar hallazgos de productos en muchas categorías, desde zapatos y ropa hasta bolsos y accesorios. En lugar de buscar en páginas dispersas, puedes ver enlaces y notas organizados en una sola vista. Es una herramienta de investigación, no una tienda — todas las compras se realizan en la plataforma principal.',

  'article.s2Title': 'Cómo Usar la USFans Spreadsheet',
  'article.s2Body': 'Empieza eligiendo una categoría que te interese y luego revisa los artículos listados y cualquier nota de QC o envío. Compara algunas opciones antes de pasar al sitio principal. Dedicar unos minutos a investigar primero suele llevar a una experiencia de compra más fluida.',

  'article.s3Title': 'Categorías de Productos Explicadas',
  'article.s3Body': 'La hoja cubre una amplia gama de categorías, que incluyen zapatos, sudaderas y suéteres, camisetas, chaquetas, pantalones y shorts, gorros y gorras, conjuntos, ropa interior, camisetas deportivas, accesorios, bolsos, cinturones, perfumes y otros artículos. Cada categoría agrupa productos relacionados para que explores de forma más eficiente.',

  'article.s4Title': 'QC y Controles de Calidad',
  'article.s4Body': 'QC, o control de calidad, es el paso en el que se inspeccionan los productos antes del envío. Muchos compradores usan fotos de QC para revisar detalles como costuras, talla y color. Si hay QC disponible para un artículo, revisa esas fotos con cuidado antes de confirmar tu pedido.',

  'article.s5Title': 'Conceptos Básicos de Envío y Almacén',
  'article.s5Body': 'El costo de envío depende de factores como el peso, las dimensiones, el destino y el nivel de servicio elegido. Algunos pedidos pasan por un almacén donde los artículos pueden guardarse, fotografiarse y consolidarse en menos paquetes — lo que a veces puede reducir el costo total de envío.',

  'article.s6Title': '¿Es USFans Seguro y Legítimo?',
  'article.s6Body': 'USFans es una plataforma real utilizada por muchos compradores, pero ningún directorio puede garantizar que cada vendedor, producto o enlace sea seguro. Verifica siempre los enlaces, la reputación del vendedor, los detalles de pago y la información del producto de forma independiente antes de comprar.',

  'article.s7Title': 'Consejos para Principiantes',
  'article.s7Body': 'Si eres nuevo, empieza con un pedido pequeño, revisa las fotos de QC cuando estén disponibles y guarda registros de tu pedido y comunicaciones. Revisa con cuidado los términos de envío y las condiciones de las promociones. Investiga primero y luego compra con confianza.',

  'article.tableTitle': 'Comparación Rápida: Investigar vs. Comprar Directamente',
  'article.tableHeaders': ['Factor', 'Investigar Primero', 'Comprar Directamente', 'Ideal Para'],
  'article.tableRows': [
    ['Costo', 'Gratis para explorar', 'Pagar al finalizar', 'Planificación de presupuesto'],
    ['Velocidad', 'Más lento (revisas primero)', 'Más rápido', 'Pedidos urgentes'],
    ['QC', 'Puedes revisar fotos', 'Puedes omitir controles', 'Compradores centrados en calidad'],
    ['Confianza', 'Mayor tras investigar', 'Depende del anuncio', 'Principiantes'],
  ],

  'article.faqTitle': 'Preguntas Frecuentes',
  'article.faq1q': '¿Qué es la USFans Spreadsheet?',
  'article.faq1a': 'Es un directorio organizado de hallazgos de productos, enlaces de categorías, notas de QC y orientación de compra que te ayuda a investigar antes de comprar.',
  'article.faq2q': '¿Es gratis usar la USFans Spreadsheet?',
  'article.faq2a': 'Explorar el directorio es gratis. Solo pagas por los artículos que decidas comprar en la plataforma principal.',
  'article.faq3q': '¿Cómo encuentro las fotos de QC?',
  'article.faq3a': 'Las fotos de QC suelen estar disponibles para los artículos que pasan por un almacén. Revisa cada anuncio en la plataforma principal para ver las imágenes de inspección disponibles.',
  'article.faq4q': '¿Todos los enlaces de la hoja son seguros?',
  'article.faq4a': 'No necesariamente. La hoja es informativa, así que verifica siempre los enlaces, vendedores y detalles de pago de forma independiente antes de comprar.',

  'article.relatedTitle': 'Guías Relacionadas',
  'article.related1': 'Volver a la página principal de USFans Spreadsheet',
  'article.related2': 'Explora todas las categorías de productos',
  'article.ctaTitle': '¿Listo para explorar?',
  'article.ctaBody': 'Abre la USFans Spreadsheet y empieza tu investigación de productos hoy.',
  'article.cta': 'Explora la USFans Spreadsheet',
};